var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 35.7089H33.6444C31.8667 35.7089 30.1778 36.3283 28.9333 37.4472L25.1333 40.8238C23.4 42.3623 20.5778 42.3623 18.8444 40.8238L15.0444 37.4472C13.8 36.3283 12.0889 35.7089 10.3333 35.7089H8.66667C4.97778 35.7089 2 33.0515 2 29.7748V7.95635C2 4.67959 4.97778 2.02222 8.66667 2.02222H35.3333C39.0222 2.02222 42 4.67959 42 7.95635V29.7548C42 33.0316 39.0222 35.7089 35.3333 35.7089Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1553 15.9085C22.0664 15.9085 21.9331 15.9085 21.822 15.9085C19.4887 15.8286 17.6442 14.1303 17.6442 12.0124C17.6442 9.85449 19.5776 8.11621 21.9776 8.11621C24.3776 8.11621 26.3109 9.87447 26.3109 12.0124C26.3331 14.1303 24.4887 15.8486 22.1553 15.9085Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8888 21.9228C12.9332 23.7011 12.9332 26.5982 15.8888 28.3765C19.2442 30.3945 24.7553 30.3945 28.1109 28.3765C31.0664 26.5982 31.0664 23.7011 28.1109 21.9228C24.7553 19.9248 19.2664 19.9248 15.8888 21.9228Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9667b134b275379024e53d26830fdda5.svg";
export { ForwardRef as ReactComponent };